export default __webpack_public_path__ + "static/media/check.0ee0f4eb.svg";